<template>
    <section :class="{ 'dark-theme': theme }">
        <div class="container position-relative">
            <div class="banner position-relative text-center">
                <img
                    src="/static/images/banner-mobile-images.png"
                    class="d-md-none position-relative top-img img-fluid"
                    alt=""
                    loading="lazy"
                    decoding="async"
                />

                <div class="row position-relative justify-content-center">
                    <div class="col-60 col-lg-40">
                        <div class="px-1 px-md-0">
                            <h2
                                class="alfa"
                                :class="[theme === 'dark' ? 'text-white' : 'primary-c']"
                            >
                                <slot name="title" />
                            </h2>
                            <p class="beta mt-2 mb-3">
                                <slot name="text" />
                            </p>

                            <slot name="button" />

                            <p class="beta mt-2">
                                <slot name="bottom-text" />
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <img
                :src="[theme === 'dark' ? '/static/images/banner-left-alt.png' : '/static/images/banner-left-images.png']"
                class="left-images position-absolute img-fluid d-none d-md-block"
                alt=""
                loading="lazy"
                decoding="async"
            />
            <img
                :src="[theme === 'dark' ? '/static/images/banner-right-alt.png' : '/static/images/banner-right-images.png']"
                class="right-images position-absolute img-fluid d-none d-md-block"
                alt=""
                loading="lazy"
                decoding="async"
            />
        </div>
    </section>
</template>

<script>
  export default {
    name: "MainBanner",
    props: {
      theme: {
        type: String,
      },
    },
  }
</script>

<style lang="scss" scoped>
@import '../../sass/abstracts/_mixins.scss';

.dark-theme {
    background-color: #0b0b0f;
    p {
        color: var(--global-color-grey-1) !important;
    }
    .banner {
        background: linear-gradient(180deg, rgba(10, 10, 10, 0.75) 48.44%, rgba(20, 20, 20, 0.95) 89.06%), url('/static/images/banner-bg.jpg') 50% / cover, #000;
        background-blend-mode: normal, luminosity, normal;
        background-size: cover
    }
}

.left-images,
.right-images {
    z-index: 7;
    bottom: -3rem;
    max-width: 18.75rem;
}

.left-images {
    left: -4rem;
    @include media-breakpoint-only(md) {
        left: -9rem;
    }
}
.right-images {
    right: -4rem;
    @include media-breakpoint-only(md) {
        right: -9rem;
    }
}

.row {
    z-index: 10;
}
.banner {
    border-radius: 1.8rem;
    padding: 7.25rem 8.1rem;
    overflow: hidden;

    @include media-breakpoint-down(md) {
        padding: 0 0 3rem 0;

        .top-img {
            z-index: 10;
        }
    }

    background: linear-gradient(180deg, rgba(254, 243, 246, 0) 0%, rgba(254, 243, 246, 0.95) 0%),
        url('/static/images/banner-bg.jpg'), #000;
    background-blend-mode: screen, normal;
    background-size: cover;
    p {
        color: #64001f;
    }
}
</style>
